import { WithTranslation, withTranslation } from 'react-i18next';
import {
    setHoursFormValues,
    updateHoursFormValue,
    stageJobHour,
    saveStagedJobHours,
    clearStagedJobHours,
    setSelectedJobHourID,
    deleteSAPJobWorkOrder,
    unlinkWorkOrders
} from '../../actions/manageJobActions';

import AddHoursModalForm from './AddHoursModalForm';
import { IinitialState } from '../../reducers';
import { WithCommonModal } from '../common/WithCommonModal';
import { connect } from 'react-redux';
import { toggleAddHoursModal } from '../../actions/manageInventoryActions';
import { initialJobHour } from '../../reducers/initialState';
import { selectIsLoading } from '../../reducers/commonReducers';
import { IjobWorkOrder, IlaborRate, IWorkOrder } from '../../models';
import { jobTypesIdEnum } from '../../models-enums';
import { selectFseUserOptions } from '../../reducers/manageJobReducer';
import filter from 'lodash/filter';
import { toastr } from 'react-redux-toastr';

interface Iprops {
    show?: boolean;
    rates?: IlaborRate[];
    isUnproductiveJob?: boolean;
    colorButton: string;
    modalClass?: string;
    shouldHideDelete?: boolean;
    secondModal?: boolean;
    disabled?: boolean;
    wideModal?: boolean;
    onClose?: () => void;
}

const mapStateToProps = (state: IinitialState, ownProps: Iprops & WithTranslation) => {
    const { selectedJob } = state.manageJob;
    const productiveType = 'productive';
    const { laborRates } = state;
    let selectedJobHour = initialJobHour;
    const selectedID = state.manageJob.selectedJobHourID;

    // Prefer a staged (unsaved) row; fall back to a saved row. Staged rows are the
    // only editable ones, so this is what the form normally loads for editing.
    if (selectedID) {
        const stagedHour = state.manageJob.tempJobHours[selectedID];
        if (stagedHour) {
            selectedJobHour = stagedHour;
        } else if (selectedJob && selectedJob.jobHours) {
            const foundHours = selectedJob.jobHours.find(item => item.id === selectedID);
            if (foundHours) {
                selectedJobHour = foundHours;
            }
        }
    }

    const hasStagedHours = Object.keys(state.manageJob.tempJobHours).length > 0;
    const title = ownProps.t('jobHoursForm.addJobHoursModalTitle');

    const laborRatesOpts: IlaborRate[] = laborRates.filter((rate: IlaborRate) => {
        return rate.type === productiveType;
    });

    const fseOptions = selectFseUserOptions(state);
    const currentUserID = state.user.id;
    const fseUsers = state.manageJob.fseUsers;

    let selectedWorkOrder: IWorkOrder | undefined = undefined;
    let selectedJobWorkOrder: IjobWorkOrder | undefined = undefined;
    if (
        selectedJob.jobTypeID === jobTypesIdEnum.inspection ||
        selectedJob.jobTypeID === jobTypesIdEnum.agsRebalancing
    ) {
        const woInUse = filter(state.manageJob.jobWorkOrdersByID, {
            jobID: selectedJob.id,
            isDeleted: false
        });

        if (woInUse.length > 0) {
            selectedJobWorkOrder = woInUse[0];
            selectedWorkOrder = state.workOrder.workOrdersByID[selectedJobWorkOrder?.workOrderID ?? ''];
        }
    }

    return {
        className: 'hours-modal job-hours-modal',
        loading: selectIsLoading(state),
        show: ownProps.show !== undefined ? ownProps.show : state.manageInventory.showAddHoursModal,
        onClose: ownProps.onClose,
        formValues: {}, // TODO need to refactor this form to save the selectedItem in redux
        laborRates: laborRatesOpts,
        selectedJob,
        selectedJobHour,
        hasStagedHours,
        fseOptions,
        fseUsers,
        currentUserID,
        title,
        selectedWorkOrder,
        selectedJobWorkOrder,
        isUnproductiveJob: ownProps.isUnproductiveJob,
        wideModal: ownProps.wideModal
    };
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = {
    toggleModal: typeof toggleAddHoursModal;
    updateFormValue: typeof updateHoursFormValue;
    setFormValues: typeof setHoursFormValues;
    stageJobHour: typeof stageJobHour;
    saveStagedJobHours: typeof saveStagedJobHours;
    clearStagedJobHours: typeof clearStagedJobHours;
    setSelectedJobHourID: typeof setSelectedJobHourID;
    onHide: typeof toggleAddHoursModal;
    deleteSAPJobWorkOrder: typeof deleteSAPJobWorkOrder;
    unlinkWorkOrders: typeof unlinkWorkOrders;
};

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: Iprops & WithTranslation) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    // Guarded close: warn before discarding unsaved staged rows. Used by both the
    // modal's backdrop/ESC dismiss (onHide) and the footer Cancel (via the form).
    onHide: () => {
        const close = () => {
            dispatchProps.setSelectedJobHourID('');
            if (ownProps.onClose) {
                ownProps.onClose();
            } else {
                dispatchProps.toggleModal();
            }
        };
        if (!stateProps.hasStagedHours) {
            close();
            return;
        }
        toastr.confirm(ownProps.t('unsavedHoursWarning'), {
            onOk: () => {
                dispatchProps.clearStagedJobHours();
                close();
            },
            onCancel: () => null,
            okText: ownProps.t('discardHoursButton'),
            cancelText: ownProps.t('common:cancel')
        });
    }
});

export default withTranslation('nsJob')(
    connect(
        mapStateToProps,
        {
            toggleModal: toggleAddHoursModal,
            updateFormValue: updateHoursFormValue,
            setFormValues: setHoursFormValues,
            stageJobHour,
            saveStagedJobHours,
            clearStagedJobHours,
            setSelectedJobHourID,
            onHide: toggleAddHoursModal,
            deleteSAPJobWorkOrder,
            unlinkWorkOrders
        },
        mergeProps
    )(WithCommonModal(AddHoursModalForm))
);
